import React, { useCallback, useEffect, useState } from 'react'
import {
  Box,
  Button,
  Flex,
  Heading,
  HStack,
  Text,
  VStack,
} from '@chakra-ui/react'
import {
  faRotateRight,
  faTriangleExclamation,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { REPOSITORY } from '../../../../api/repository/Repository'
import Table from '../../../../components/Table/Table'
import Toast from '../../../../components/Toast/Toast'
import UnderlineHeading from '../../../../components/UnderlineText/UnderlineHeading'
import {
  formatBlockData,
  formatResetCards,
} from '../../../../utils/formats/formats'
import { useLoadingContext } from '../../../../utils/hooks/Context/LoadingContext'
import { useRequestStatusContext } from '../../../../utils/hooks/Context/RequestStatusContext'
import { useLabels } from '../../../../utils/hooks/useLabels/useLabels'
import { colors } from '../../../../utils/theme/styles'
import { columns } from './temporalData'
import SearchBar from '../../../../components/SearchBar/SearchBar'
import Selector from '../../../../components/Selector/Selector'
import {
  approveAssignmentErrorsUpper,
  approveReassignErrorsUpper,
  denyAssignmentErrorsUpper,
  denyReassignErrorsUpper,
} from '../../../../variables/errors'
const filterOptions = [
  { id: 'AC', value: 'AC', label: 'Activos' },
  { id: 'PA', value: 'PA', label: 'Enrolamiento por activar' },
  { id: 'RA', value: 'RA', label: 'Reasignacion por aprobar' },
  { id: 'SU', value: 'SU', label: 'Suspendidos' },
  { id: 'EP', value: 'EP', label: 'En Proceso' },
  { id: 'DV', value: 'DV', label: 'Desvinculado' },
]

const responseColumns = [
  {
    Header: 'Bolsillo NN',
    accessor: 'sEmpleado',
  },
  {
    Header: 'Mensaje',
    accessor: 'sMensaje',
  },
]
export default function CardManagement() {
  const { texts } = useLabels()
  const [blockedCells, setBlockedCells] = useState([])
  const [cardSelected, setCardSelected] = useState(null)
  const [dataNN, setDataNN] = useState([])
  const [searchState, setSearchState] = useState('')
  const handleChangeSearch = (event) => setSearchState(event.target.value)
  const [pagination, setPagination] = useState({ page: 1, totalPages: 0 })
  const {
    handleOpen,
    handleSetTitle,
    handleChangeBody,
    handleClose,
    isOpen,
    handleChangeCustomColor,
  } = useRequestStatusContext()
  const { handleOpen: handleOpenLoading, handleClose: handleCLoseLoading } =
    useLoadingContext()
  const [status, setStatus] = useState('')

  const handleChangeStatus = useCallback((newValue) => {
    setStatus(newValue)
  }, [])

  const handleChangeCard = useCallback((newCard) => {
    if (newCard) {
      const newCards = newCard.map((el) => el.original)
      if (newCard.length > 0) {
        const status = filterOptions
        const selectedStatus =
          newCard[0]?.original.sEstadoEnrolamiento ||
          newCard[0]?.original.sEstado
        const foundedIndex = filterOptions.findIndex(
          (element) => element.id === selectedStatus,
        )
        const deleted = status.slice(foundedIndex, foundedIndex + 1)

        setBlockedCells([...deleted])
      } else {
        setBlockedCells([])
      }
      setCardSelected(newCards)
    }
  }, [])

  const resetBlockedCells = () => {
    setBlockedCells([])
    handleChangeCard([])
  }

  const handleGetDataNN = async (page) => {
    handleOpenLoading()
    const newData = await REPOSITORY.wsEmpresa.accounts.noNominative.listNN({
      nPagina: page,
      nEmpleadosPagina: 30,
      sBusqueda: searchState,
      sEstado: status,
    })
    handleCLoseLoading()
    setDataNN(newData.data.cDatosEmpleados)
    setPagination({
      page: newData.data.nPagina,
      totalPages: newData.data.nPaginasTotal,
    })
    resetBlockedCells()
  }

  const handleSearch = () => {
    setDataNN(null)
    handleGetDataNN(1)
  }

  useEffect(() => {
    if (!isOpen) {
      setDataNN([])
      handleGetDataNN(1)
    }
  }, [isOpen])

  const validateCell = (row) => {
    if (blockedCells.length === 0) return true
    if (row.original.sEstadoEnrolamiento) {
      return !!blockedCells.some(
        (element) => element.id === row.original.sEstadoEnrolamiento,
      )
    }
    return !!blockedCells.some((element) => element.id === row.original.sEstado)
  }

  const handleOkStatus = ({ status, title }) => {
    handleCLoseLoading()
    handleSetTitle(title, status)
    handleChangeBody(
      <Button variant="primary" onClick={handleClose}>
        {status === 200 ? 'Continuar' : 'Contactar a soporte ahora'}
      </Button>,
    )
    handleOpen()
  }
  const handleOkApprove = ({
    status,
    title,
    approved,
    errorWallets,
    action,
  }) => {
    handleCLoseLoading()
    handleSetTitle(title, status)
    handleChangeBody(
      <VStack width="100%" justifyContent="flex-start">
        <Heading variant="h5">Bolsillos {action} con exito</Heading>
        <Table data={approved} columns={responseColumns} />
        <Heading variant="h5">Bolsillos con error</Heading>
        <Table data={errorWallets} columns={responseColumns} />
        <Button variant="primary" onClick={handleClose}>
          {status === 200 ? 'Continuar' : 'Contactar a soporte ahora'}
        </Button>
        ,
      </VStack>,
    )
    handleOpen()
  }

  const handleBlock = async () => {
    if (cardSelected?.length > 0) {
      handleOpenLoading()
      await REPOSITORY.wsEmpresa.accounts.noNominative
        .blockCard(formatBlockData(cardSelected))
        .then(async (response) => {
          await handleGetDataNN(pagination.page).then(() => {
            handleOkStatus({
              title: 'Se bloqueó la Cuenta NN con exito',
              status: response.status,
            })
            resetBlockedCells()
          })
        })
    }
  }

  const handleReset = async () => {
    if (cardSelected?.length > 0) {
      handleOpenLoading()
      await REPOSITORY.wsEmpresa.accounts.noNominative
        .resetCard(formatResetCards(cardSelected))
        .then(async (response) => {
          handleOkStatus({
            title: 'Se restableció los accesos iniciales de la NN',
            status: response.status,
          })
          resetBlockedCells()
        })
    }
  }
  const cardsToIds = () => {
    return cardSelected.map((element) => ({ id: element.nIdEnrolamiento }))
  }

  const handleApprove = async () => {
    handleOpenLoading()
    if (cardSelected[0]?.sEstadoEnrolamiento === 'RA') {
      await REPOSITORY.wsEmpresa.accounts.noNominative
        .multiApproveReasign(cardsToIds())
        .then(async (res) => {
          const errorWallets = res.data.filter((el) =>
            approveReassignErrorsUpper.includes(el.sMensaje.toUpperCase()),
          )
          const approvedWallets = res.data.filter(
            (el) =>
              !approveReassignErrorsUpper.includes(el.sMensaje.toUpperCase()),
          )

          handleOkApprove({
            status: approvedWallets.length > 0 ? 200 : 500,
            title:
              errorWallets.length > 0
                ? 'Se presentaron algunos errores'
                : 'Bolsillos aprobados con exito',
            approved: approvedWallets,
            errorWallets,
            action: 'aprobados',
          })
          resetBlockedCells()
        })
    } else {
      await REPOSITORY.wsEmpresa.accounts.noNominative
        .multiApproveEnrollment(cardsToIds())
        .then(async (res) => {
          const errorWallets = res.data.filter((el) =>
            approveAssignmentErrorsUpper.includes(el.sMensaje.toUpperCase()),
          )
          const approvedWallets = res.data.filter(
            (el) =>
              !approveAssignmentErrorsUpper.includes(el.sMensaje.toUpperCase()),
          )
          handleOkApprove({
            status: approvedWallets.length > 0 ? 200 : 500,
            title:
              errorWallets.length > 0
                ? 'Se presentaron algunos errores'
                : 'Bolsillos aprobados con exito',
            approved: approvedWallets,
            errorWallets,
            action: 'aprobados',
          })

          resetBlockedCells()
          handleGetDataNN(1)
        })
    }
  }
  const handleDeny = async () => {
    handleOpenLoading()
    if (cardSelected[0]?.sEstadoEnrolamiento === 'RA') {
      await REPOSITORY.wsEmpresa.accounts.noNominative
        .multiDenyReasign(cardsToIds())
        .then(async (res) => {
          let errorWallets = []
          let approvedWallets = []
          if (Array.isArray(res.data)) {
            errorWallets = res.data.filter((el) =>
              denyReassignErrorsUpper.includes(el.sMensaje.toUpperCase()),
            )
            approvedWallets = res.data.filter(
              (el) =>
                !denyReassignErrorsUpper.includes(el.sMensaje.toUpperCase()),
            )
          } else {
            if (denyReassignErrorsUpper.includes(res.data.sMensaje)) {
              errorWallets = [res.data]
              approvedWallets = []
            } else {
              errorWallets = []
              approvedWallets = [res.data]
            }
          }
          handleChangeCustomColor(colors.secondary.base)

          handleOkApprove({
            status: approvedWallets.length > 0 ? 200 : 500,
            title:
              errorWallets.length > 0
                ? 'Se presentaron algunos errores'
                : 'Bolsillos rechazados con exito',
            approved: approvedWallets,
            errorWallets,
            action: 'rechazados',
          })

          resetBlockedCells()
          handleGetDataNN(1)
        })
    } else {
      await REPOSITORY.wsEmpresa.accounts.noNominative
        .multiDenyEnrolment(cardsToIds())
        .then(async (res) => {
          let errorWallets = []
          let approvedWallets = []
          if (Array.isArray(res.data)) {
            errorWallets = res.data.filter((el) =>
              denyAssignmentErrorsUpper.includes(el.sMensaje.toUpperCase()),
            )
            approvedWallets = res.data.filter(
              (el) =>
                !denyAssignmentErrorsUpper.includes(el.sMensaje.toUpperCase()),
            )
          } else {
            if (denyAssignmentErrorsUpper.includes(res.data.sMensaje)) {
              errorWallets = [res.data]
              approvedWallets = []
            } else {
              errorWallets = []
              approvedWallets = [res.data]
            }
          }
          handleChangeCustomColor(colors.secondary.base)

          handleOkApprove({
            status: approvedWallets.length > 0 ? 200 : 500,
            title:
              errorWallets.length > 0
                ? 'Se presentaron algunos errores'
                : 'Bolsillos rechazados con exito',
            approved: approvedWallets,
            errorWallets,
            action: 'rechazados',
          })

          resetBlockedCells()
        })
    }
  }

  // useEffect(() => {
  //   setDataNN(dataNN)
  // }, [cardSelected])

  return (
    <Flex direction="column" mb="50px">
      <Box>
        <UnderlineHeading
          text={texts.nn_account_management}
          variant="h5"
          subtext={texts.nn_account_management_description}
          subVariant="body1"
        />
      </Box>
      <Box mt="50px">
        <Heading variant="h5">{texts.search_by_dni_or_nn}</Heading>
      </Box>
      <Box mt="23px">
        <VStack alignItems="flex-start">
          <HStack justifyContent="flex-start" spacing="20px">
            <Box w="250px">
              <SearchBar
                handleSearch={handleChangeSearch}
                value={searchState}
              />
            </Box>
            <Box w="200px">
              <Selector
                options={filterOptions}
                onChange={handleChangeStatus}
                isClearable
                placeholder="TODOS"
              />
            </Box>
            <Box>
              <Button
                w="70px"
                border="transparent"
                variant="white"
                onClick={handleSearch}
              >
                <Text variant="button">Buscar</Text>
              </Button>
            </Box>
          </HStack>
          {dataNN && (
            <Table
              handleSelected={handleChangeCard}
              validateSelectable={validateCell}
              isSelectable
              columns={columns}
              data={dataNN}
              withPagination
              paginationProps={{
                totalPages: pagination.totalPages,
                actualPage: pagination.page,
                handlePageChange: handleGetDataNN,
              }}
            />
          )}
        </VStack>
      </Box>

      <Box mt="8px">
        <Heading variant="h5">
          {cardSelected?.length !== 0
            ? texts.disponible_actions
            : 'No hay acciones disponibles. Debes seleccionar un bolsillo NN'}
        </Heading>
      </Box>
      {cardSelected?.length !== 0 && (
        <Box mt="28px" w="100%">
          <HStack px="32px" width="100%" gap="32px">
            {!['RA', 'PA'].includes(blockedCells[0]?.id) && (
              <>
                <Toast
                  as="button"
                  onClick={handleReset}
                  bgColor={colors.secondary.base}
                  disabled={cardSelected?.length === 0}
                  width="max-content"
                >
                  <HStack
                    ml={4}
                    spacing="16px"
                    justifyContent="start"
                    alignItems="center"
                    h="100%"
                    w="max-content"
                  >
                    <FontAwesomeIcon
                      color="white"
                      size="lg"
                      icon={faRotateRight}
                    />
                    <Text color="white" variant="semibold" fontSize={14}>
                      REESTABLECER ACCESOS
                    </Text>
                  </HStack>
                </Toast>
                <Toast
                  as="button"
                  onClick={handleBlock}
                  disabled={cardSelected?.length === 0}
                  bgColor={colors.log.error}
                >
                  <HStack
                    ml={4}
                    spacing="16px"
                    justifyContent="start"
                    alignItems="center"
                    h="100%"
                    w="100%"
                  >
                    <FontAwesomeIcon
                      color="white"
                      size="lg"
                      icon={faTriangleExclamation}
                    />
                    <Text color="white" variant="semibold" fontSize={14}>
                      BLOQUEAR BOLSILLO
                    </Text>
                  </HStack>
                </Toast>
              </>
            )}
            {cardSelected && ['RA', 'PA'].includes(blockedCells[0]?.id) && (
              <Toast
                as="button"
                variant="cardManagement"
                onClick={handleDeny}
                disabled={cardSelected?.length === 0}
                bgColor={colors.log.error}
                border={null}
              >
                <Text color="white" variant="semibold" fontSize={14}>
                  Rechazar
                </Text>
              </Toast>
            )}
            {cardSelected && ['RA', 'PA'].includes(blockedCells[0]?.id) && (
              <Toast
                as="button"
                onClick={handleApprove}
                disabled={cardSelected?.length === 0}
                bgColor={colors.primary.base}
                variant="cardManagement"
              >
                <Text color="white" variant="semibold" fontSize={14}>
                  Aprobar
                </Text>
              </Toast>
            )}
          </HStack>
        </Box>
      )}
    </Flex>
  )
}
